export const MAX_NUMBER_OF_REACTION_PER_SESSION = 50;